import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatComponent } from './chat/chat.component';
import { TareasComponent } from './tareas/tareas.component';
import { BancosComponent } from './bancos/bancos.component';
import { ClientesProveedoresWizardComponent } from './clientes-proveedores-wizard/clientes-proveedores-wizard.component';
import { CompradorComponent } from './comprador/comprador.component';
import { ProductosComponent } from './productos/productos.component';
import { VendedorComponent } from './vendedor/vendedor.component';
import { MatCurrencyFormatModule } from 'mat-currency-format';
import { GeneralesRoutingModule } from './generales-routing.module';
import { AdminTareasComponent } from './admin-tareas/admin-tareas.component';
import { PagarCobranzaComponent } from './pagar-cobranza/pagar-cobranza.component';
import { PagarProveedorComponent } from './pagar-proveedor/pagar-proveedor.component';
import { UsuarioProfileComponent } from './usuario-profile/usuario-profile.component';
import { ComprobacionPagoLoadingComponent } from '../../inicio/paginas/comprobacion-pago-loading/comprobacion-pago-loading.component';
import { RenovacionLicenciaComponent } from './renovacion-licencia/renovacion-licencia.component';
import { VcardGeneratorComponent } from './vcard-generator/vcard-generator.component';
import { ImportsModule } from 'app/oDres/importsmodule/imports';
import { ComponentesComunesModule } from 'app/oDres/comunes/componentes-comunes.module';
import { TipoCambioDollarComponent } from './tipo-cambio-dollar/tipo-cambio-dollar.component';
import { DragulaModule } from 'ng2-dragula';
import { LotesComponent } from './lotes/lotes.component';
import { NotaContableCruceComponent } from './nota-contable-cruce/nota-contable-cruce.component';

@NgModule({
  declarations: [
    ChatComponent,
    TareasComponent,
    BancosComponent,
    ClientesProveedoresWizardComponent,
    CompradorComponent,
    ProductosComponent,
    VendedorComponent,
    AdminTareasComponent,
    PagarCobranzaComponent,
    PagarProveedorComponent,
    UsuarioProfileComponent,
    ComprobacionPagoLoadingComponent,
    RenovacionLicenciaComponent,
    VcardGeneratorComponent,
    TipoCambioDollarComponent,
    LotesComponent,
    NotaContableCruceComponent,
  ],
  imports: [
    CommonModule,
    GeneralesRoutingModule,
    ComponentesComunesModule,
    DragulaModule.forRoot(),
    ImportsModule
  ],
  exports: [
    MatCurrencyFormatModule,
    TareasComponent,
    BancosComponent,
    ClientesProveedoresWizardComponent,
    CompradorComponent,
    ProductosComponent,
    VendedorComponent,
    PagarCobranzaComponent,
    PagarProveedorComponent,
    UsuarioProfileComponent,
    RenovacionLicenciaComponent,
    VcardGeneratorComponent,
    TipoCambioDollarComponent,
    LotesComponent,
    NotaContableCruceComponent
  ],
})
export class GeneralesModule { }
